/*
 *  IRIS Interactive
 *
 *  NOTICE OF LICENSE
 *  This source file is no subject to a specific license
 *  but it belongs to the company IRIS Interactive.
 *  You can contact IRIS Interactive at the following
 *  address: contact@iris-interactive.fr
 *
 *  @author      Stephan JAMBOU
 *  @date        31/05/2022 09:50
 *  @copyright   Copyright (c) 2002-2021 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class IrisHoverComponent {
    /**
     * Manage hover on touchscreen
     */
    constructor() {
        let isTouched = false

        window.addEventListener("mousedown", () => {
            if (!isTouched) {
                const body = document.body
                body.classList.add("iris-hover")
            }
        })

        window.addEventListener("mouseup", () => {
            isTouched = false
        })

        window.addEventListener("touchstart", () => {
            isTouched = true
            const body = document.body
            body.classList.remove("iris-hover")
        })
    }
}
